import { render, staticRenderFns } from "./openproblemvideo.vue?vue&type=template&id=50c02165&scoped=true"
import script from "./openproblemvideo.vue?vue&type=script&lang=js"
export * from "./openproblemvideo.vue?vue&type=script&lang=js"
import style0 from "./openproblemvideo.vue?vue&type=style&index=0&id=50c02165&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c02165",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c02165')) {
      api.createRecord('50c02165', component.options)
    } else {
      api.reload('50c02165', component.options)
    }
    module.hot.accept("./openproblemvideo.vue?vue&type=template&id=50c02165&scoped=true", function () {
      api.rerender('50c02165', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/openproblemvideo.vue"
export default component.exports